import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer mt-auto py-3 bg-white text-dark">
            <div className="container">
                <div className="row">
                    <div className="col-md-3 footer-left">
                        <div>
                            <a className="footer-logo" href="#about">
                                <img src='/images/logo.svg' alt='Logo' /> <br />
                                <span><em>We deliver efficiency</em></span>
                            </a>
                        </div>

                        <div className='search-input d-flex me-3'>
                            <img src='/images/search.svg' alt='Search' className='search-input-image' />
                            <input className='search-input-text' placeholder='Search' />
                        </div>

                        <div>
                            <h5>Contact Us</h5>
                            <p>12a chess close, Frenda str, Ijoki, Agosi state, Nigeria</p>
                            <p>Phone: +234 70 880 86 624</p>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <h5>HR Solutions</h5>
                        <ul className="list-unstyled">
                            <li>Benefits Administration</li>
                            <li>Employee Self-Service</li>
                            <li>Compliance and Legal</li>
                            <li>Time and Attendance Tracking</li>
                            <li>Partner with Us</li>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <h5>Help</h5>
                        <ul className="list-unstyled">
                            <li>Blog</li>
                            <li>Team</li>
                            <li>About us</li>
                            <li>Careers</li>
                            <li>Cultural Values</li>
                        </ul>
                    </div>
                    <div className="col-md-3">
                        <h5>Our Company</h5>
                        <ul className="list-unstyled">
                            <li>FAQs</li>
                            <li>Locations</li>
                            <li>Contect Us</li>
                            <li>Resources/Articles</li>
                            <li>Partner with Us</li>
                        </ul>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="list-unstyled list-logo">
                            <li><a href="/"><img src="/images/email.svg" alt="Mail" className="social-icon" /></a></li>
                            <li><a href="/"><img src="/images/whatsapp.svg" alt="WhatsApp" className="social-icon" /></a></li>
                            <li><a href="/"><img src="/images/fb.svg" alt="Facebook" className="social-icon" /></a></li>
                            <li><a href="/"><img src="/images/linkedin.svg" alt="LinkedIn" className="social-icon" /></a></li>
                            <li><a href="/"><img src="/images/ig.svg" alt="Instagram" className="social-icon" /></a></li>
                            <li><a href="/"><img src="/images/twitter.svg" alt="Twitter" className="social-icon" /></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
